export default {
	root: {
		fontFamily: 'Prompt'
	},
	notchedOutline: {
		borderColor: 'rgba(0,0,0,0.15)'
	}
};
